// This file was auto-generated by __GENERATE_CHAIN_PRESETS__.js. Do not edit manually.

import { kroma as _kroma } from 'viem/chains'
import { createCommon } from '../createCommon.js'

/**
 * Creates a common configuration for the kroma chain.
 * @type {import('../Common.js').Common}
 * @description
 * Chain ID: 255
 * Chain Name: Kroma
 * Default Block Explorer: https://blockscout.kroma.network
 * Default RPC URL: https://api.kroma.network
 * @example
 * import { createMemoryClient } from 'tevm'
 * import { kroma } from 'tevm/common'
 * import { http } from 'tevm'
 *
 * const client = createMemoryClient({
 *   common: kroma,
 *   fork: {
 *     transport: http({ url: 'https://example.com' })({})
 *   },
 * })
 */
export const kroma = createCommon({
	..._kroma,
	loggingLevel: 'warn',
	eips: [],
	hardfork: 'prague',
})
